import { useState } from 'react';
import { withRouter } from 'react-router';

import { Icon, IconButton, Menu, MenuItem } from '@material-ui/core';

import { AdminPolicy, useCheckPolicy } from '../../pages/policies';

export function FaqButton({ history }) {
  const isAdmin = useCheckPolicy(AdminPolicy);

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <>
      <IconButton
        onClick={(e) => {
          setOpen(!open);
          setAnchorEl(e.currentTarget);
        }}
        color='inherit'
      >
        <Icon fontSize='medium' style={{ color: '#f9f9f9' }}>
          {'help'}
        </Icon>
      </IconButton>
      <Menu
        id='menu-faqs'
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={() => {
          setOpen(false);
          setAnchorEl(null);
        }}
      >
        {isAdmin && (
          <MenuItem
            component='a'
            onClick={() => {
              setOpen(false);
              setAnchorEl(null);
              history.push('/monitor');
            }}
          >
            Tellus Monitor
          </MenuItem>
        )}
        <MenuItem
          component='a'
          onClick={() => {
            setOpen(false);
            setAnchorEl(null);
            history.push('/faq');
          }}
        >
          FAQ
        </MenuItem>
      </Menu>
    </>
  );
}

export default withRouter(FaqButton);
